<form class="form-inline">
  <div class="form-group hidden">
    <input name="datepicker"
            class="form-control"
            ngbDatepicker
            #datepicker="ngbDatepicker"
            [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)"
            [displayMonths]="2"
            [dayTemplate]="t"
            outsideDays="hidden"
            [startDate]="fromDate!"
            tabindex="-1">
    <ng-template #t let-date let-focused="focused">
      <span class="custom-day"
            [class.focused]="focused"
            [class.range]="isRange(date)"
            [class.faded]="isHovered(date) || isInside(date)"
            (mouseenter)="hoveredDate = date"
            (mouseleave)="hoveredDate = null">
        {{ date.day }}
      </span>
    </ng-template>
  </div>
  <div class="form-group">
    <label class="top-label">{{ 'Date range:' | translate }}</label>
    <div class="input-group">
      <input #dpFromDate
             class="form-control" placeholder="yyyy-mm-dd"
             name="dpFromDate"
             [value]="formatter.format(fromDate)"
             (input)="manualInput('fromDate', dpFromDate.value)">
      <input #dpToDate
             class="form-control" placeholder="yyyy-mm-dd"
             name="dpToDate"
             [value]="formatter.format(toDate)"
             (input)="manualInput('toDate', dpToDate.value)">
      <div class="input-group-append">
        <button class="btn btn-outline-secondary" (click)="datepicker.toggle()" type="button">
          <i class="fas fa-calendar"></i>
        </button>
      </div>
    </div>
  </div>
</form>
